import * as React from 'react';
const hidesLayers = [];
const exclusionLayers = ['background', 'gl-draw', 'vector', 'stand', 'estateLayer', 'standLayers'];
const useMapDisplayLayers = (isExclusionLayersHide, map) => {
    const [styleLoaded, setStyleLoaded] = React.useState(false);
    React.useEffect(() => {
        if (!map)
            return;
        const isStyleLoaded = map.isStyleLoaded();
        const setTrueSelected = () => {
            setStyleLoaded(true);
        };
        if (!isStyleLoaded)
            map.on('styledata', setTrueSelected);
        return () => {
            map.off('styledata', setTrueSelected);
        };
    }, [map]);
    React.useEffect(() => {
        if (!map || !styleLoaded)
            return;
        displayExclusionLayers(map, isExclusionLayersHide);
    }, [map, styleLoaded, isExclusionLayersHide]);
};
export default useMapDisplayLayers;
const displayExclusionLayers = (map, isExclusionLayersHide) => {
    const layersStyle = map.getStyle().layers;
    if (!layersStyle)
        return;
    for (let i = 0; i < layersStyle.length; i += 1) {
        if (isExclusionLayersHide) {
            let haveExclusion = false;
            for (let j = 0; j < exclusionLayers.length; j += 1) {
                if (layersStyle[i].id.includes(exclusionLayers[j]))
                    haveExclusion = true;
            }
            if (!haveExclusion)
                map.setLayoutProperty(layersStyle[i].id, 'visibility', 'none');
        }
        else {
            if (hidesLayers.filter(val => val === layersStyle[i].id).length === 0)
                map.setLayoutProperty(layersStyle[i].id, 'visibility', 'visible');
        }
    }
};
